export const EVENT_HISTORY = {
    HEADER_TEXT: "Add Event History",
    WORD_LIMIT: 500

}

export const WORKSHOP = {
    HEADER_TEXT: "Workshop Reason",
    WORD_LIMIT: 100
}